import styled from 'styled-components';

import { breakpoint } from '../../../themes/breakpoints';

export const Wrapper = styled.div`
  z-index: -1;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  & .submit-button {
    margin: 10px 1px;
  }

  & .submit-button:hover {
    background-color: ${(props) => props.theme.colors.lightBlack} !important;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }

  & .existing-email-login-link {
    text-decoration: underline;
  }

  & .password-field.MuiTextField-root > .MuiFilledInput-root {
    padding-right: 0;
  }

  & .password-field.MuiTextField-root .MuiFilledInput-input {
    padding-right: 50px;
  }

  & .form-field-helper {
    color: ${(props) => props.theme.colors.errorRed};
    font-size: 12px;
    line-height: 18px;
    text-align: left;
  }

  ${breakpoint('sm')`
    padding-bottom: 100px;
  `}

  ${breakpoint('md')`
    padding-bottom: 40px;
  `}

  ${breakpoint('lg')`
    padding-bottom: 20px;
  `}
`;

export const BackBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 18px;
  left: 16px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: 1px solid ${(props) => props.theme.colors.darkGreyOpacity01};
  transition: border-color 0.15s;
  transition-timing-function: ease-out;

  &:hover {
    border-color: ${(props) => props.theme.colors.darkGrey};
  }

  ${breakpoint('md')`
    top: 16px;
    left: 22px;
  `}
`;

export const LoginLink = styled.p`
  text-align: center;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.darkGrey};
  & a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.darkGrey};
  }

  ${breakpoint('md')`
  font-size: 12px;
`}
`;

export const Subtitle = styled.p`
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.darkGrey};
`;

export const CheckboxGroup = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & .MuiFormControlLabel-root {
    margin-left: 0;
    align-items: flex-start;
  }

  & .MuiCheckbox-root {
    padding: 4px 8px 4px 0;
    margin-top: 2px;
  }

  & .MuiFormControlLabel-label {
    font-size: 12px;
    line-height: 18px;
    color: ${(props) => props.theme.colors.darkGrey};
    text-align: left;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;

  & .MuiButton-root {
    margin: 0 1px;
  }

  ${breakpoint('md')`
    width: auto;
    padding: 0;

    & .MuiButton-root {
      margin: 10px 1px;
    }
  `}
`;

export const PasswordIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 18px;
`;

export const Privacy = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
  a {
    text-decoration: underline;
  }
`;

export const Agreement = styled.div`
  font-size: 10px;
  text-align: left;
  margin: 10px 0; // spacing this Agreement Text, the input boxes, and the action button
  display: flex; // flex with column direction, to add a gap between each <p> section of 5px
  flex-direction: column;
  gap: 5px;
  a {
    text-decoration: underline;
    font-weight: bold;
  }
`;
